import { render, staticRenderFns } from "./AccessIcon.vue?vue&type=template&id=19334aac&"
import script from "./AccessIcon.vue?vue&type=script&lang=js&"
export * from "./AccessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccessIcon.vue"
export default component.exports